import React, { FC, ReactNode } from 'react'
import {
  Button,
  CircularProgress,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  List,
  ListItem,
  ListItemText,
} from '@mui/material'
import { DialogNames } from 'src/enums'
import { StatefulDialog } from 'src/components/ui'

interface SelectedSensor {
  uniqueId: string
  imei: string | number | null
}

interface BulkConfirmationModalProps {
  name: DialogNames
  title: string
  confirmationText: ReactNode
  selectedSensors: SelectedSensor[]
  confirmLabel?: string
  onConfirm: () => void
  onClose: () => void
  isLoading?: boolean
}

export const BulkConfirmationModal: FC<BulkConfirmationModalProps> = ({
  name,
  title,
  confirmationText,
  selectedSensors,
  confirmLabel = 'Confirm',
  onConfirm,
  onClose,
  isLoading = false,
}) => (
  <StatefulDialog
    name={name}
    onClose={onClose}
    actions={
      <DialogActions>
        <Button onClick={onClose} disabled={isLoading}>
          Cancel
        </Button>
        <Button onClick={onConfirm} disabled={isLoading}>
          {isLoading ? <CircularProgress size={22} /> : confirmLabel}
        </Button>
      </DialogActions>
    }
  >
    <DialogTitle>{title}</DialogTitle>
    <DialogContent>
      <DialogContentText>{confirmationText}</DialogContentText>
      <List dense sx={{ maxHeight: 300, overflowY: 'auto' }}>
        {selectedSensors.map((sensor) => (
          <ListItem key={sensor.uniqueId} disableGutters>
            <ListItemText primary={sensor.imei} />
          </ListItem>
        ))}
      </List>
    </DialogContent>
  </StatefulDialog>
)
